import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "melt-cookie-notice-dismissed";

/**
 * Essential-cookies notice. MELT stores only one strictly-necessary
 * preference (this dismissal flag) in localStorage. No analytics or
 * tracking cookies are set by the site, so no consent toggles are needed —
 * we simply inform the visitor, per UK PECR / GDPR guidance.
 */
export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* storage unavailable — dismiss for this session only */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-0 bottom-0 z-[60] max-h-[80vh] overflow-y-auto border-t border-melt-grey bg-white shadow-[0_-6px_24px_rgba(46,42,91,0.08)]"
      data-testid="cookie-notice"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-5 py-5 md:flex-row md:items-center md:justify-between md:px-8">
        <p className="text-[15px] leading-relaxed text-melt-indigo">
          This website uses only strictly necessary cookies.{" "}
          <Link
            to="/data-protection"
            className="font-medium text-melt-teal underline underline-offset-2 hover:text-melt-teal-600"
            data-testid="cookie-policy-link"
          >
            Read our Data Protection and Cookie Policy
          </Link>
          .
        </p>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 rounded-md bg-melt-teal px-5 py-2.5 text-[15px] font-semibold text-white transition-colors hover:bg-melt-teal-600"
          data-testid="cookie-accept-button"
        >
          Understood
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
